import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatBottomSheet} from '@angular/material';
import {Subscription} from 'rxjs';
import {HeaderService} from '../../../../services/header.service';
import {MessageService} from '../../../../services/message.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {SortConsentBottomSheetComponent} from '../sort-consent-bottom-sheet/sort-consent-bottom-sheet.component';

@Component({
    selector: 'app-parent-personal-messages',
    templateUrl: './parent-personal-messages.component.html',
    styleUrls: ['./parent-personal-messages.component.scss']
})
export class ParentPersonalMessagesComponent implements OnInit, OnDestroy {
    isLoading: boolean;
    messages: any = [];
    displayMessages: any = [];
    listHeight;
    subscription: Subscription;

    constructor(private headerService: HeaderService,
                private messageService: MessageService,
                private bottomSheet: MatBottomSheet,
                private toastService: ToastMessagesService) {
        this.isLoading = true;
        this.listHeight = window.innerHeight - 100;

    }

    async ngOnInit(): Promise<void> {
        try {
            this.initSubscriptions();
            await this.initComponent();
        } catch (e) {
            this.toastService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    async initPersonalMessages() {
        this.messages = await this.messageService.getMyMessages();
        this.displayMessages = [...this.messages];
    }


    initSubscriptions() {
        this.subscription = this.headerService.observerShowBottomSheet().subscribe(state => {
            if (state) {
                this.openBottomSheet();
            }
        });
    }


    async initComponent() {
        this.headerService.setHeaderTitle(`Τα μηνύματά μου`);
        await this.initPersonalMessages();
    }

    async preview(id: number) {
        await this.messageService.displayMessage(id);
    }

    openBottomSheet() {
        const bottomSheet = this.bottomSheet.open(SortConsentBottomSheetComponent, {
            data: {
                items: [
                    {
                        key: 'sent_date',
                        label: 'Ημερομηνία μηνύματος',
                        type: 'date',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}
                    },
                    {
                        key: 'sent_date',
                        label: 'Ημερομηνία μηνύματος',
                        type: 'date',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}
                    },
                    {
                        key: 'subject',
                        label: 'Τίτλος Θέματος',
                        type: 'string',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}

                    },
                    {
                        key: 'subject',
                        label: 'Τίτλος Θέματος',
                        type: 'string',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}

                    }
                ]
            }
        });

        bottomSheet.afterDismissed().subscribe(response => {
            if (response) {
                this.sortMessages(response.key, response.type, response.order.key);
                this.headerService.setShowBottomSheet(false);
            }
        });
    }

    sortMessages(sortBy: string = null, type: string = null, direction: string = null) {
        try {
            this.isLoading = true;
            this.displayMessages = [];
            if (direction) {
                if (direction === 'asc') {
                    if (type === 'date') {
                        this.messages.sort((a, b) => (this.stringToDate(a[sortBy]) > this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) > this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.messages.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : (b[sortBy] > a[sortBy]) ? -1 : 0);
                    }
                } else {
                    if (type === 'date') {
                        this.messages.sort((a, b) => (this.stringToDate(a[sortBy]) < this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) < this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.messages.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : (b[sortBy] < a[sortBy]) ? -1 : 0);
                    }
                }
            }

            this.displayMessages = [...this.messages];
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }

    private stringToDate(dateString: string): Date {
        try {
            const tempString = dateString.split('-');
            const tempTime = tempString[2].split(' ');
            const year = tempTime[0];
            const month = tempString[1];
            const day = tempString[0];
            const time = tempTime[1];

            const formattedDateString = `${year}-${month}-${day} ${time}`;
            return new Date(formattedDateString);
        } catch (e) {
            return null;
        }
    }
}
